
window.addEventListener("klaviyoForms", function(e) {
                if (e.detail.type == 'submit') {
                    // debugger;
                    switch (e.detail.formId) {
                        case "RGutgq":
                            checkForMysteryItem();
                            break;
                    }
                }
});

function checkForMysteryItem() {
                console.log('Mystery gift triggered.');
                    // Your function code here
                var variantId = '42303997378751'; // Replace with the variant ID
                var quantity = 1; // You can adjust the quantity if needed
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: quantity,
                        id: variantId
                    },
                    success: function(data) {
                        // Product added successfully
                        console.log('Product added to cart:', data);

                        // Trigger the "rebuy cart" functionality
                        $.getJSON('/cart.js', function(cart) {
                            console.log('Rebuy cart triggered:', cart);
                            // You can customize further actions after rebuy here
                        });
                    },
                    error: function(error) {
                        console.error('Error adding product to cart:', error);
                    }
                });
            
}